export var LiveWireV2Routes = {
    "/live-wire-v2": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.live-wire-v2",
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Livewire"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"},
            {
                type: 'chunk',
                loader: function () {
                    return import("./live-wire-v2.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../reports/tl-reports.module.js");
                }
            }
        ],
        "views": {
            "body": {
                component: "liveWireV2Component"
            }
        },
    },
};
